import React from 'react';

const ActivoGrid = ({ activos }) => {
  const calcularDepreciacion = (valor, vida) => {
    return (valor / vida).toFixed(2);
  };

  return (
    <table className="grilla">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Categoría</th>
          <th>Valor</th>
          <th>Vida útil</th>
          <th>Depreciación anual</th>
          <th>Foto</th>
          <th>Factura</th>
        </tr>
      </thead>
      <tbody>
        {activos.map((a, i) => (
          <tr key={i}>
            <td>{a.nombre}</td>
            <td>{a.categoria}</td>
            <td>${a.valor}</td>
            <td>{a.vida} años</td>
            <td>${calcularDepreciacion(a.valor, a.vida)}</td>
            <td>{a.foto && <img src={a.foto} alt="foto" width={40} />}</td>
            <td>{a.factura && <span>{a.factura}</span>}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ActivoGrid;